import React from 'react';
import { SpringGrid } from 'react-stonecutter';
import { connect } from 'react-redux';

import './index.css';
import ArticlePreview from '../../components/articlePreview';
import articlesList from './articles';
import anetworkPreview from '../../images/blog/anetwork-preview.jpg';
import sonderPreview from '../../images/blog/sonder-preview.jpg';

const articlePreviews = [anetworkPreview, sonderPreview];
export const articles = articlesList.map((article, index) => Object.assign({}, article, { image: articlePreviews[index] }));

class Blog extends React.Component {
  blogFilters = React.createRef();
  state = {
    currentFilter: 'all',
    columns: 2,
    columnWidth: 581,
    gutterWidth: 20,
    itemHeight: 305,
    originalX: 0,
    moveX: 0
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let cw = nextProps.clientWidth;
    if (cw <= 415) {
      return {
        columns: 1,
        columnWidth: 400,
        gutterWidth: 20,
        itemHeight: 580
      }
    }
    else if (cw <= 868) {
      return {
        columns: 1,
        columnWidth: 600,
        gutterWidth: 20,
        itemHeight: 580
      }
    }
    else if (cw <= 1200) {
      return {
        columns: 2,
        columnWidth: 400,
        gutterWidth: 15,
        itemHeight: 550
      }
    }
    else if (cw <= 1400) {
      return {
        columns: 2,
        columnWidth: 480,
        gutterWidth: 15,
        itemHeight: 550
      }
    } else {
      return {
        columns: 2,
        columnWidth: 581,
        gutterWidth: 20,
        itemHeight: 600
      }
    }
  }

  getFilteredArticles = (filter) => {
    return filter === 'all' ? articles : articles.filter(work => work.type === filter);
  }

  handleFilterChange = (filter, e) => {
    this.setState({ currentFilter: filter });
  }

  handleScroll = () => {
    let scroll = window.pageYOffset || document.documentElement.scrollTop;
    const blogFilters = this.blogFilters.current;
    if (window.innerWidth >= 1201) {
      if (scroll >= 490) {
        blogFilters.classList.add('blog__header__filters-fixed');
      }
      else if (scroll <= 491) {
        blogFilters.classList.remove("blog__header__filters-fixed");
      }
    }
    else if (window.innerWidth >= 1001 && window.innerWidth <= 1200) {
      if (scroll >= 370) {
        blogFilters.classList.add('blog__header__filters-fixed');
      }
      else if (scroll <= 371) {
        blogFilters.classList.remove("blog__header__filters-fixed");
      }
    }
    else if (window.innerWidth <= 1000 && window.innerWidth >= 541) {
      if (scroll >= 321) {
        blogFilters.classList.add('blog__header__filters-fixed');

      }
      else if (scroll <= 320) {
        blogFilters.classList.remove("blog__header__filters-fixed");
      }
    }

    else if (window.innerWidth <= 540 && window.innerWidth >= 415) {
      if (scroll >= 381) {
        blogFilters.classList.add('blog__header__filters-fixed');
      }
      else if (scroll <= 380) {
        blogFilters.classList.remove("blog__header__filters-fixed");
      }
    }
    else if (window.innerWidth <= 414) {
      if (scroll >= 285) {
        blogFilters.classList.add('blog__header__filters-fixed');
      }
      else if (scroll <= 286) {
        blogFilters.classList.remove("blog__header__filters-fixed");
      }
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  render() {

    return (
      <div className="blog page">
        <div className="blog__header">
          <h1>{localStorage.getItem('lang') == 'ru'? 'Блог':'Blog'}</h1>
          <span className="subtitle">{localStorage.getItem('lang') == 'ru'? 'Пишем об интересных проектах и решениях':
          'We write about interesting projects and solutions'}</span>
          <div className="blog__header__filters__wrapper" ref={this.blogFilters}>
            <div className="blog__header__filters__scroller">
              <div className="blog__header__filters">
                <span
                  onClick={() => this.handleFilterChange("all")}
                  className={["blog__header__filter",
                    this.state.currentFilter === "all" ? "blog__header__filter-active" : ""].join(" ")}>
                    {localStorage.getItem('lang') == 'ru'? 'Все статьи':'All articles'}
              </span>
                <span
                  onClick={() => this.handleFilterChange("design")}
                  className={["blog__header__filter",
                    this.state.currentFilter === "design" ? "blog__header__filter-active" : ""].join(" ")}>
                  {localStorage.getItem('lang') == 'ru'? 'Дизайн':'Design'}
              </span>
                <span
                  onClick={() => this.handleFilterChange("promo")}
                  className={["blog__header__filter",
                    this.state.currentFilter === "promo" ? "blog__header__filter-active" : ""].join(" ")}>
                  {localStorage.getItem('lang') == 'ru'? 'Промо':'Promo'}
              </span>
                <span
                  onClick={() => this.handleFilterChange("about")}
                  className={["blog__header__filter",
                    this.state.currentFilter === "about" ? "blog__header__filter-active" : ""].join(" ")}>
                  {localStorage.getItem('lang') == 'ru'? 'О компании':'About'}
              </span>
              </div>
            </div>
          </div>
        </div>
        <div className="blog__body">
          <div className="blog__articles">
            <SpringGrid
              component="ul"
              columns={this.state.columns}
              columnWidth={this.state.columnWidth}
              gutterWidth={this.state.gutterWidth}
              gutterHeight={25}
              itemHeight={this.state.itemHeight}
              springConfig={{ stiffness: 170, damping: 26 }}>
              {this.getFilteredArticles(this.state.currentFilter).map(article =>
                <div key={article.title}>
                  <ArticlePreview
                    key={article.title}
                    {...article} />
                </div>)}
            </SpringGrid>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ clientWidth }) => {
  return {
    clientWidth
  }
}

export default connect(mapStateToProps)(Blog);



// WEBPACK FOOTER //
// ./src/pages/blog/index.jsx